import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 19.8799991607666 2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 19.8799991607666 2\" id=\"icon-close\"><g><path d=\"M18.8859,2L0.994062,2C0.445331,2,0,1.55199,0,1.00008C0,0.448007,0.445312,0,0.994062,0L18.8859,0C19.4357,0,19.88,0.448007,19.88,1.00008C19.88,1.55199,19.4357,2,18.8859,2Z\" fill=\"#1A173B\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol